"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveContactErrorType = exports.CONTACT_ARCHIVAL_REASONS = exports.ContactStatusReason = exports.ContactStatus = exports.ContactFor = void 0;
/**
 * Values for ContactFor field. Additionally, this field may be also an array of specific LOCs
 */
var ContactFor;
(function (ContactFor) {
    ContactFor["ALL"] = "ALL";
    ContactFor["CERTIFICATES"] = "CERTIFICATES";
    ContactFor["INVOICES"] = "INVOICES";
    ContactFor["EXPOSURES"] = "EXPOSURES";
    ContactFor["SIGNATURES"] = "SIGNATURES";
    ContactFor["CLAIMS"] = "CLAIMS";
    ContactFor["LOSS_CONTROL"] = "LOSS_CONTROL";
    ContactFor["PROPOSALS"] = "PROPOSALS";
})(ContactFor = exports.ContactFor || (exports.ContactFor = {}));
var ContactStatus;
(function (ContactStatus) {
    ContactStatus["ACTIVE"] = "ACTIVE";
    ContactStatus["ARCHIVED"] = "ARCHIVED";
})(ContactStatus = exports.ContactStatus || (exports.ContactStatus = {}));
var ContactStatusReason;
(function (ContactStatusReason) {
    ContactStatusReason["ACCOUNT_ARCHIVED"] = "ACCOUNT_ARCHIVED";
    ContactStatusReason["ACCOUNT_UNARCHIVED"] = "ACCOUNT_UNARCHIVED";
    ContactStatusReason["CREATED"] = "CREATED";
    ContactStatusReason["DUPLICATE_DETECTED_DURING_ACCOUNT_MERGE"] = "DUPLICATE_DETECTED_DURING_ACCOUNT_MERGE";
    ContactStatusReason["MANUALLY_ARCHIVED"] = "MANUALLY_ARCHIVED";
    ContactStatusReason["MANUALLY_UNARCHIVED"] = "MANUALLY_UNARCHIVED";
    ContactStatusReason["MIGRATED"] = "MIGRATED";
    ContactStatusReason["VALIDATE_IMPORTED_BOR_FAILED"] = "VALIDATE_IMPORTED_BOR_FAILED";
})(ContactStatusReason = exports.ContactStatusReason || (exports.ContactStatusReason = {}));
exports.CONTACT_ARCHIVAL_REASONS = [
    ContactStatusReason.ACCOUNT_ARCHIVED,
    ContactStatusReason.MANUALLY_ARCHIVED,
    ContactStatusReason.DUPLICATE_DETECTED_DURING_ACCOUNT_MERGE,
    ContactStatusReason.VALIDATE_IMPORTED_BOR_FAILED,
];
var ArchiveContactErrorType;
(function (ArchiveContactErrorType) {
    ArchiveContactErrorType["PARENT_ACCOUNT_IS_NOT_ARCHIVED"] = "PARENT_ACCOUNT_IS_NOT_ARCHIVED";
    ArchiveContactErrorType["LAST_KEY_CONTACT_FROM_REPLICABLE_ACCOUNT"] = "LAST_KEY_CONTACT_FROM_REPLICABLE_ACCOUNT";
})(ArchiveContactErrorType = exports.ArchiveContactErrorType || (exports.ArchiveContactErrorType = {}));
//# sourceMappingURL=contact.js.map